"use client";

import { sessionStorageCleanup } from "@/utils/helper";
import { signIn, signOut } from "next-auth/react";
import { createContext, useCallback, useContext, useMemo } from "react";

type eventContextType = {
  handleSFSignOutEvent: (options?: { callbackUrl?: string }) => void;
  handleSFSignInEvent: (options?: { callbackUrl?: string }) => void;
};

const EventContext = createContext<eventContextType | undefined>(undefined);

const EventContextProvider = ({ children }: { children: React.ReactNode }) => {
  const handleSFSignOutEvent = useCallback(
    async (options?: { callbackUrl?: string }) => {
      const callbackUrl = options?.callbackUrl ?? "";

      sessionStorageCleanup("logoutCleanup");

      await signOut({ callbackUrl });
    },
    []
  );

  const handleSFSignInEvent = useCallback(
    async (options?: { callbackUrl?: string }) => {
      const callbackUrl = options?.callbackUrl ?? "";

      await signIn("salesforce", { callbackUrl });
    },
    []
  );

  const value = useMemo(
    () => ({
      handleSFSignOutEvent,
      handleSFSignInEvent,
    }),
    [handleSFSignOutEvent, handleSFSignInEvent]
  );

  return (
    <EventContext.Provider value={value}>{children}</EventContext.Provider>
  );
};

const useEventContext = () => {
  const context = useContext(EventContext);
  if (!context) {
    throw new Error("useEventContext must be within a EventContextProvider");
  }
  return context;
};

export { EventContextProvider, useEventContext };
